module.exports = __webpack_public_path__ + "img/customer_headimg.23a1e64f.png";